import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ProductData from '../page/ProductData';
import { useDispatch } from 'react-redux'
import { addToCart } from '../redux/cartSlice'
function Owl() {
  const dispatch = useDispatch();
  return (
    <>
      <div className="container border-top border-danger border-3 py-4 my-4">
        <h1 className='text-center pt-5 pb-4'>Featured Products</h1>
  <div className="row">
    
    <div className="col-lg-12">
    <OwlCarousel className='owl-theme' loop margin={10} items={4}nav>
        {ProductData.map((a)=>(
          <div className='card'>
          <img className='w-100 owl' src={a.image}/>
          <div className='card-body'>
             <p className='fw-bold'>{a.title}</p>
             <div className='star pt-3'>
             <i class="bi bi-star-fill pe-2 text-warning"></i>
             <i class="bi bi-star-fill pe-2 text-warning"></i>
             <i class="bi bi-star-fill pe-2 text-warning"></i>
             <i class="bi bi-star-fill text-body-tertiary pe-2"></i>
             <i class="bi bi-star-fill text-body-tertiary"></i>
             </div>
             <p className='fw-bold pt-2'>Rs.{a.price}</p>
                 <span className="text-center d-flex py-3">
                    <p className='pe-2 text-decoration-line-through text-body-tertiary'>Rs.800</p>
                    <p>-5%</p>
                     </span>
             <div className='text-start mb-3'>
             <button type="button" class="btn btn-dark" onClick={() => dispatch(addToCart(a))}>Add to Cart</button>
               </div>
          </div>
       </div>
        ))}
        </OwlCarousel>
      </div>
    </div>
  </div>
    </>
  )
}

export default Owl
